<template>
  <div>
    <div v-if="!isEdit" class="p-mypage_registration__password">
      <div class="p-mypage_registration__title">
        <p class="f_18 bold">パスワード変更</p>
        <p class="edit"><a href="javascript:void(0);" @click="edit()">編集する<img src="/images/pc/edit.png" alt=""></a></p>
      </div>
      <table class="p-mypage_registration__password__table">
        <tr>
          <th>パスワード</th>
          <td>●●●●●●●●</td>
        </tr>
      </table>
    </div>

    <div v-if="isEdit" class="p-mypage_registration__password">
        <div class="p-mypage_registration__title">
          <p class="f_18 bold">パスワード変更</p>
        </div>
        <form @submit.prevent="handleSubmit">
          <table class="p-mypage_registration__password__table">
            <tr>
              <th>現在のパスワード</th>
              <td>
                <text-input type="password" v-model="form.params.old_password"/>
                <error-message v-if="form.errors.first('old_password')" :message="form.errors.first('old_password')"></error-message>
              </td>
            </tr>
            <tr>
              <th>新しいパスワード</th>
              <td>
                <text-input type="password" v-model="form.params.password"/>
                <span>※半角英数字6文字以上</span>
                <error-message v-if="form.errors.first('password')" :message="form.errors.first('password')"></error-message>
              </td>
            </tr>
            <tr>
              <th>新しいパスワード（確認）</th>
              <td>
                <text-input type="password" v-model="form.params.confirm_password"/>
                <span>※半角英数字6文字以上</span>
                <error-message v-if="form.errors.first('confirm_password')" :message="form.errors.first('confirm_password')"></error-message>
              </td>
            </tr>
          </table>
          <div class="submit">
            <input type="submit" value="パスワード変更" :disabled="sending">
          </div>
        </form>
      </div>
    </div>
</template>

<script>
import Form from "@/utils/Form";
import TextInput from '@/shared/Input/TextInput'
import ErrorMessage from '@/shared/Input/ErrorMessage'

export default {
  props: {
    user: {
      type: Array | Object | null,
      default: null,
      required: false,
    },
    isMobile : {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  components: {
    TextInput,
    ErrorMessage
  },
  data() {
    return {
      form: new Form({
        old_password: '',
        password: '',
        confirm_password: ''
      }),
      sending: false,
      isSuccess: false,
      isEdit: false
    }
  },
  methods: {
    handleSubmit () {
      if (this.sending == true) {
        return;
      }
      this.sending = true;

      this.form
        .put({
          url: "/mypage/password/" + this.user.id,
        })
        .then(({}) => {
          this.isSuccess = true;
          flash('更新しました。', 'success');
          window.scrollTo(0, 0);
          this.sending = false;
          this.isEdit = false;
        })
        .catch((error) => {
          this.sending = false;
        });
    },

    edit() {
      this.isEdit = true;
    }
  },
  mounted() {
  },
  computed: {
  },
  created() {
  },
}
</script>
